module.exports = __webpack_public_path__ + "static/media/greenup.f8e44e3a.png";